import $ from 'jquery'

const update_pros = function(){
  const value = $("#pros_and_cons_card_statistic_pros_id option:selected").text();
  if(value == ""){
    $('#pros').show()
  }else{
    $('#pros').hide()
  }
}

const update_cons = function(){
  const value = $("#pros_and_cons_card_statistic_cons_id option:selected").text();
  if(value == ""){
    $('#cons').show()
  }else{
    $('#cons').hide()
  }
}

$('#pros_and_cons_card_statistic_pros_id').change(function() {
  update_pros()
});

$('#pros_and_cons_card_statistic_cons_id').change(function() {
  update_cons()
});

update_pros()
update_cons()

$("select.icons").imagepicker()

$(function() {
  if($('.invalid-feedback').length){
    $('#icon-collapse-button').click()
  }
});
